import {LitElement, html, css} from 'lit';

export class ModalElement extends LitElement {
    static get styles() {
        return css`
            .modal {
                position: fixed;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: rgba(0, 0, 0, 0.5);
                z-index: 10;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
            }
            .modal-header {
                display: flex;
                align-items: center;
                padding: 0;
                justify-content: space-between;
            }
            .modal-header h2 {
                margin: 0;
                padding: 0;
            }
            .modal-close {
                border: none;
                background: none;
                color: #fff;
                font-size: 1.5rem;
                cursor: pointer;
                max-width: 80%;
            }
            .modal-body {
                padding: 1rem;
                background: rgb(69, 66, 66);
                border-radius: 0.5rem;
                margin: 1em;
                box-shadow: 1px 5px 10px 1px rgba(7, 7, 7, 0.5);
                max-width: 80%;
            }
        `;
    }
    
    static get properties() {
        return {
            id: {
                type: String,
            },
            title: {
                type: String
            },
        };
    }

    constructor() {
        super();
        this.id = '';
        this.title = 'Message';
    }

    render() {
        return html`
            <div class="modal">
                <div class="modal-body">
                    <div class="modal-header">
                        <h2>${this.title}</h2>
                        <button class="modal-close" @click="${this.close}">X</button>
                    </div>
                    <slot></slot>
                </div>
            </div>
        `;
    }

    close() {
        this.dispatchEvent(new CustomEvent(
            'close',
            {
                bubbles: true,
                composed: true,
                detail: {
                    id: this.id,
                }
            }
        ));
    }
}

window.customElements.define('modal-element', ModalElement);